module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate/college-store/iowa-state-university-58d7b21455ec7398be2545eb396d2f3e.jpg";